import { VenueDetailsType } from '@api';
import { TouringCardTable, TouringCardTableBody } from '@common';
import { GeneralInformationTableRow } from './components';
import { generalInformationRows } from './data';

type GeneralInformationTablePropsType = {
  venue: VenueDetailsType;
};

export const GeneralInformationTable: React.FC<
  GeneralInformationTablePropsType
> = ({ venue }) => {
  return (
    <TouringCardTable>
      <TouringCardTableBody>
        {generalInformationRows.map((row) => (
          <GeneralInformationTableRow key={row.label} venue={venue} row={row} />
        ))}
      </TouringCardTableBody>
    </TouringCardTable>
  );
};
